<template>
<div>
    <side-bar>
        <b-button class='btn-lvl-1' @click="vendors=!vendors">Vendors</b-button>
        <mobile-menu slot="content"></mobile-menu>
        <div v-if="vendors">
            <sidebar-link to="/views/vendors">
                <i class="nc-icon nc-badge"></i>
                <p>Overview</p>
            </sidebar-link>
            <b-button class='btn-lvl-2' @click="tier1=!tier1">Tier 1</b-button>
            <div v-if='tier1'>
                <sidebar-link to="/views/aws">
                    <i class="nc-icon nc-badge"></i>
                    <p>AWS</p>
                </sidebar-link>
                <sidebar-link to="/views/aws-ri">
                    <i class="nc-icon nc-badge"></i>
                    <p>AWS RI Portfolio</p>
                </sidebar-link>
                <sidebar-link to="/views/aws-sp">
                    <i class="nc-icon nc-badge"></i>
                    <p>AWS Savings Plans</p>
                </sidebar-link>
                <sidebar-link to="/views/cloudability">
                    <i class="nc-icon nc-badge"></i>
                    <p>Cloudability</p>
                </sidebar-link>
                <sidebar-link to="/views/akamai">
                    <i class="nc-icon nc-badge"></i>
                    <p>Akamai</p>
                </sidebar-link>
                <sidebar-link to="/views/logzio">
                    <i class="nc-icon nc-badge"></i>
                    <p>LogzIO</p>
                </sidebar-link>
                <sidebar-link to="/views/newrelic">
                    <i class="nc-icon nc-badge"></i>
                    <p>NewRelic</p>
                </sidebar-link>
            </div>
            <br>
            <b-button class='btn-lvl-2' @click="tier2=!tier2">Tier 2</b-button>
            <div v-if='tier2'>
                <sidebar-link to="/views/edrans">
                    <i class="nc-icon nc-badge"></i>
                    <p>Edrans</p>
                </sidebar-link>
                <sidebar-link to="/views/pagerduty">
                    <i class="nc-icon nc-badge"></i>
                    <p>Pager Duty</p>
                </sidebar-link>
                <sidebar-link to="/views/gitlab">
                    <i class="nc-icon nc-badge"></i>
                    <p>Gitlab</p>
                </sidebar-link>

            </div>
            <b-button class='btn-lvl-2' @click="tier3=!tier3">Tier 3</b-button>
            <div v-if='tier3' style="text-align: center;">
                <span>None</span>
            </div>
            <b-button class='btn-lvl-2' @click="tier4=!tier4">Tier 4</b-button>
            <div v-if='tier4' style="text-align: center;">
                <span>None</span>

            </div>
        </div>
        <b-button class='btn-lvl-1' @click="services=!services">Olx Services</b-button>
        <div v-if="services">
            <sidebar-link to="/views/git">
                <i class="nc-icon nc-preferences-circle-rotate"></i>
                <p>GIT Costs</p>
            </sidebar-link>
            <sidebar-link to="/views/tls">
                <i class="nc-icon nc-preferences-circle-rotate"></i>
                <p>TLS Costs</p>
            </sidebar-link>
            <sidebar-link to="/views/logstack">
                <i class="nc-icon nc-preferences-circle-rotate"></i>
                <p>Logstack Costs</p>
            </sidebar-link>
            <!--
        <sidebar-link to="/views/datavisor">
          <i class="nc-icon nc-preferences-circle-rotate"></i>
          <p>Datavisor Usage</p>
        </sidebar-link>
        -->
        </div>
        <b-button class='btn-lvl-1' @click="customer_units=!customer_units">Customer Units</b-button>
        <div v-if="customer_units">
          <sidebar-link to="/views/customer-units/central">
            <i class="nc-icon nc-preferences-circle-rotate"></i>
            <p>Central</p>
          </sidebar-link>
          <sidebar-link to="/views/customer-units/central-not-verticals">
            <i class="nc-icon nc-preferences-circle-rotate"></i>
            <p>Central NOT VERTICALS</p>
          </sidebar-link>
          <sidebar-link to="/views/customer-units/olx-eu">
            <i class="nc-icon nc-preferences-circle-rotate"></i>
            <p>OLX EU</p>
          </sidebar-link>
        </div>

        <b-button class='btn-lvl-1' @click="teams=!teams">Olx Business Units</b-button>
        <div v-if="teams">
            <sidebar-link to="/business-units/data">
                <i class="nc-icon nc-preferences-circle-rotate"></i>
                <p>Data</p>
            </sidebar-link>
            <sidebar-link to="/views/business-units/plutus">
                <i class="nc-icon nc-preferences-circle-rotate"></i>
                <p>Payments & Monetisation</p>
            </sidebar-link>
            <sidebar-link to="/views/business-units/shared-css-user-pack">
                <i class="nc-icon nc-preferences-circle-rotate"></i>
                <p>Shared CSS User Pack</p>
            </sidebar-link>
            <sidebar-link to="/views/business-units/panamera">
                <i class="nc-icon nc-preferences-circle-rotate"></i>
                <p>Panamera</p>
            </sidebar-link>
        </div>
        <b-button class='btn-lvl-1' @click="units=!units">Organizatinal Units</b-button>
        <div v-if="units">
            <sidebar-link to="/views/organizations/central">
                <i class="nc-icon nc-preferences-circle-rotate"></i>
                <p>Central</p>
            </sidebar-link>
            <sidebar-link to="/views/organizations/europe">
                <i class="nc-icon nc-preferences-circle-rotate"></i>
                <p>Europe</p>
            </sidebar-link>
            <sidebar-link to="/views/organizations/mena">
                <i class="nc-icon nc-preferences-circle-rotate"></i>
                <p>Mena</p>
            </sidebar-link>
            <sidebar-link to="/views/organizations/latam">
                <i class="nc-icon nc-preferences-circle-rotate"></i>
                <p>LATAM</p>
            </sidebar-link>
            <sidebar-link to="/views/organizations/india">
                <i class="nc-icon nc-preferences-circle-rotate"></i>
                <p>India</p>
            </sidebar-link>
            <sidebar-link to="/views/organizations/indonesia">
                <i class="nc-icon nc-preferences-circle-rotate"></i>
                <p>Indonesia</p>
            </sidebar-link>
            <sidebar-link to="/views/organizations/ssa">
                <i class="nc-icon nc-preferences-circle-rotate"></i>
                <p>SSA</p>
            </sidebar-link>
        </div>
        <sidebar-link to="/views/tier/1">
            <b-button class='btn-lvl-1'>Have your vendor here!</b-button>
        </sidebar-link>

    </side-bar>
    <div class="main-panel">
        <top-navbar></top-navbar>

        <dashboard-content @click="toggleSidebar">

        </dashboard-content>

        <content-footer></content-footer>
    </div>
</div>
</template>

<script>
import TopNavbar from './TopNavbar.vue'
import ContentFooter from './ContentFooter.vue'
import DashboardContent from './Content.vue'
import MobileMenu from './MobileMenu.vue'

export default {
    components: {
        TopNavbar,
        ContentFooter,
        DashboardContent,
        MobileMenu
    },
    data() {
        return {
            vendors: true,
            tier1: true,
            tier2: false,
            tier3: false,
            tier4: false,
            services: false,
            units: false,
            teams: false,
            customer_units: false,
        }
    },
    methods: {}
}
</script>

<style lang="scss" scoped>
.btn-lvl-1 {
    border-color: darkseagreen;
    background-color: darkslategray;
    color: snow;
    width: 99%;
    font-weight: bold;
    padding: 2px 2px;
    cursor: pointer;
}

.btn-lvl-2 {
    border-color: darkseagreen;
    background-color: darkslategray;
    color: snow;
    width: 99%;
    cursor: pointer;
    padding: 2px 2px;

}
</style>
